import Udesk from 'Udesk';
import UdeskLocales from 'UdeskLocales';
import React from 'react';
import { Checkbox, Radio, Button, Alert, InputNumber, Select, Space, Tabs } from 'udesk-ui';
import TasksAutomaticAddRoute from './route';
import Page from 'Component/common/udesk-qa-page-layout';
import TaskAssessRulesGather from 'Component/pages/components/task-assess-rules-gather';
import TaskConditionGather from 'Component/pages/components/task-condition-gather';
import UdeskList from 'Component/common/udesk-list';
import MassageConfiguration from 'Component/pages/components/massage-configuration';
import CardLayout from './components/card-layout';
import AutoAddComponent from 'Component/pages/components/auto-add-component';
import AutoAdd from './components/auto-add';
import SamplingTarget from 'Component/pages/components/sampling-target';
import TopicAnalysisTable from './topic-analysis';
import BusinessSummaryTable from './components/business-summary';
import CusTabs from './components/CusTabs';
import CaseConfig from './components/CaseConfig';
import BusinessConfig from './components/business-config';
import AutoAssign from './components/AutoAssign';
import ViewGrade from './components/view-grade';
import { getTabPanes } from './const';
import './style-new.scss';

export default class TasksAutomaticAddTemplate extends TasksAutomaticAddRoute {
    render() {
        let { actions, locales, props, privates } = this;
        let hasFeature = props.sdkOptions.props.task
            ? props.sdkOptions.props.task._hasFeature
            : null;
        const isWechatQa = [
            Udesk.enums.inspectDataSources.wechatDialogue.id,
            Udesk.enums.inspectDataSources.wechatRadio.id,
        ].includes(this.privates.type);
        const isCollection =
            props.sdkOptions.props.task.taskType === Udesk.enums.taskType.informationCollection.id;
        const isTicket = privates.type === Udesk.enums.inspectDataSources.ticket.id;
        const isComment =
            privates.type === Udesk.enums.inspectDataSources.eComment.id ||
            privates.type === Udesk.enums.inspectDataSources.mComment.id;
        const isFeishuGroup = privates.type === Udesk.enums.inspectDataSources.feishuGroup.id;
        const isEText = privates.type === Udesk.enums.inspectDataSources.taobao.id;

        const tabPanes = getTabPanes({
            isWechatQa,
            isCollection,
            isTicket,
            isFeishuGroup,
            isEText,
        });

        const disabled = !hasFeature || !hasFeature('task:template:auto:edit');

        return (
            <Page
                pageBodyClassName="tasks-manage-template-automatic-add-page"
                title={locales.pages.tasks.manage.template.automaticAdd.index.name}
                // padding={true}
                footer={
                    <Tabs
                        onChange={actions.changeActiveTab}
                        activeKey={privates.activeKey}
                        size="small"
                    >
                        {tabPanes.map((item) => (
                            <Tabs.TabPane key={`${item.key}`} tab={item.tab}></Tabs.TabPane>
                        ))}
                    </Tabs>
                }
            >
                <If condition={hasFeature && hasFeature('task:template:auto:view')}>
                    <If condition={this.privates.model.processCreateStatus.processStatus === 4}>
                        <Alert
                            message={locales.pages.tasks.manage.template.basicInfo.index.conduct4}
                            type="info"
                            closeText={locales.pages.tasks.manage.template.basicInfo.index.quit}
                            onClose={actions.exitBoot}
                        />
                    </If>

                    <CusTabs list={tabPanes} activeKey={privates.activeKey}>
                        {/* 1、自动添加 */}
                        {this.privates.type !== Udesk.enums.inspectDataSources.mixedType.id ? (
                            <CardLayout
                                cardId="automaticAddition"
                                title={
                                    UdeskLocales.current.pages.tasks.manage.template.automaticAdd
                                        .index.automaticAddition
                                }
                                tip={
                                    UdeskLocales.current.pages.tasks.manage.template.automaticAdd
                                        .index.automaticAdditionTip
                                }
                                showContent={Boolean(privates.model.processStatus.AUTOLOAD)}
                                switchProps={{
                                    checked: privates.model.processStatus.AUTOLOAD === 1,
                                    onChange: () => actions.changeStatus('AUTOLOAD'),
                                    disabled: !hasFeature || !hasFeature('task:template:auto:edit'),
                                }}
                                canEdit={hasFeature && hasFeature('task:template:auto:edit')}
                                onSave={actions.saveAutomaticAddition}
                            >
                                <AutoAddComponent
                                    isEdit={
                                        privates.conditionList.length &&
                                        hasFeature &&
                                        hasFeature('task:template:auto:edit')
                                    }
                                    judgeStrategy={
                                        privates.model.automaticAdd.baseFilter.judgeStrategy
                                    }
                                    customJudgeLogic={
                                        privates.model.automaticAdd.baseFilter.customJudgeLogic
                                    }
                                    conditionList={privates.conditionList}
                                    editFilterOhter={actions.editFilterOhter}
                                    fieldsFilterChange={actions.fieldsFilterChange}
                                    querryType="manualAdd"
                                    cancel={actions.handleConditionCancel}
                                    applyAction={actions.handleConditionApply}
                                    customName={privates.customName}
                                    customId={privates.customId}
                                    type={privates.type}
                                    // taskId={this.props.match.params.taskId}
                                    taskName={this.props.sdkOptions.props.task.name}
                                    filterList={['f_8', 'f_4', 'f_6', 'f_7', 'r_1', 'r_2', 'r_3']}
                                    disabled={
                                        !(hasFeature && hasFeature('task:template:auto:edit'))
                                    }
                                    autoMateLoadConf={privates.model.automaticAdd.autoMateLoadConf}
                                    isAutoExecute={privates.model.automaticAdd.isAutoExecute}
                                    onTimingAddChange={actions.onTimingAddChange}
                                    isCollection={isCollection}
                                />
                            </CardLayout>
                        ) : (
                            <CardLayout
                                cardId="automaticAddition"
                                title={
                                    UdeskLocales.current.pages.tasks.manage.template.automaticAdd
                                        .index.automaticAddition
                                }
                                tip={
                                    UdeskLocales.current.pages.tasks.manage.template.automaticAdd
                                        .index.automaticAdditionTip
                                }
                                showContent={true}
                                canEdit={hasFeature && hasFeature('task:template:auto:edit')}
                                onSave={actions.saveAutomaticAdditionMixed}
                            >
                                <AutoAdd
                                    textProps={{
                                        showForm: Boolean(
                                            privates.model.processStatus.MIXED_AUTOLOAD?.[
                                                Udesk.enums.inspectDataSources.textDialogue.id
                                            ]
                                        ),
                                        switchProps: {
                                            checked:
                                                privates.model.processStatus.MIXED_AUTOLOAD?.[
                                                    Udesk.enums.inspectDataSources.textDialogue.id
                                                ] === 1,
                                            onChange: () =>
                                                actions.changeStatus(
                                                    'MIXED_AUTOLOAD',
                                                    Udesk.enums.inspectDataSources.textDialogue.id
                                                ),
                                            disabled:
                                                !hasFeature ||
                                                !hasFeature('task:template:auto:edit'),
                                        },
                                        isEdit:
                                            privates.conditionList_text.length &&
                                            hasFeature &&
                                            hasFeature('task:template:auto:edit'),
                                        judgeStrategy:
                                            privates.model.automaticAdd.text.baseFilter
                                                .judgeStrategy,
                                        customJudgeLogic:
                                            privates.model.automaticAdd.text.baseFilter
                                                .customJudgeLogic,
                                        conditionList: privates.conditionList_text,
                                        editFilterOhter: actions.editFilterOhterText,
                                        fieldsFilterChange: actions.fieldsFilterChange,
                                        querryType: 'manualAdd',
                                        cancel: actions.handleConditionCancel,
                                        applyAction: actions.handleConditionApplyText,
                                        customName: privates.customName,
                                        customId: privates.customId,
                                        type: Udesk.enums.inspectDataSources.textDialogue.id,
                                        // taskId={this.props.match.params.taskId}
                                        taskName: this.props.sdkOptions.props.task.name,
                                        filterList: [
                                            'f_8',
                                            'f_4',
                                            'f_6',
                                            'f_7',
                                            'r_1',
                                            'r_2',
                                            'r_3',
                                        ],
                                        disabled: !(
                                            hasFeature && hasFeature('task:template:auto:edit')
                                        ),
                                        autoMateLoadConf:
                                            privates.model.automaticAdd.text.autoMateLoadConf,
                                        isAutoExecute:
                                            privates.model.automaticAdd.text.isAutoExecute,
                                        onTimingAddChange: actions.onTimingAddChangeText,
                                        isCollection: isCollection,
                                    }}
                                    voiceProps={{
                                        showForm: Boolean(
                                            privates.model.processStatus?.MIXED_AUTOLOAD?.[
                                                Udesk.enums.inspectDataSources.voiceCall.id
                                            ]
                                        ),
                                        switchProps: {
                                            checked:
                                                privates.model.processStatus?.MIXED_AUTOLOAD?.[
                                                    Udesk.enums.inspectDataSources.voiceCall.id
                                                ] === 1,
                                            onChange: () =>
                                                actions.changeStatus(
                                                    'MIXED_AUTOLOAD',
                                                    Udesk.enums.inspectDataSources.voiceCall.id
                                                ),
                                            disabled:
                                                !hasFeature ||
                                                !hasFeature('task:template:auto:edit'),
                                        },
                                        isEdit:
                                            privates.conditionList_voice.length &&
                                            hasFeature &&
                                            hasFeature('task:template:auto:edit'),
                                        judgeStrategy:
                                            privates.model.automaticAdd.voice.baseFilter
                                                .judgeStrategy,
                                        customJudgeLogic:
                                            privates.model.automaticAdd.voice.baseFilter
                                                .customJudgeLogic,
                                        conditionList: privates.conditionList_voice,
                                        editFilterOhter: actions.editFilterOhterVoice,
                                        fieldsFilterChange: actions.fieldsFilterChange,
                                        querryType: 'manualAdd',
                                        cancel: actions.handleConditionCancel,
                                        applyAction: actions.handleConditionApplyVoice,
                                        customName: privates.customName,
                                        customId: privates.customId,
                                        type: Udesk.enums.inspectDataSources.voiceCall.id,
                                        // taskId={this.props.match.params.taskId}
                                        taskName: this.props.sdkOptions.props.task.name,
                                        filterList: [
                                            'f_8',
                                            'f_4',
                                            'f_6',
                                            'f_7',
                                            'r_1',
                                            'r_2',
                                            'r_3',
                                        ],
                                        disabled: !(
                                            hasFeature && hasFeature('task:template:auto:edit')
                                        ),
                                        autoMateLoadConf:
                                            privates.model.automaticAdd.voice.autoMateLoadConf,
                                        isAutoExecute:
                                            privates.model.automaticAdd.voice.isAutoExecute,
                                        onTimingAddChange: actions.onTimingAddChangeVoice,
                                        isCollection: isCollection,
                                    }}
                                    ticketProps={{
                                        showForm: Boolean(
                                            privates.model.processStatus?.MIXED_AUTOLOAD?.[
                                                Udesk.enums.inspectDataSources.ticket.id
                                            ]
                                        ),
                                        switchProps: {
                                            checked:
                                                privates.model.processStatus?.MIXED_AUTOLOAD?.[
                                                    Udesk.enums.inspectDataSources.ticket.id
                                                ] === 1,
                                            onChange: () =>
                                                actions.changeStatus(
                                                    'MIXED_AUTOLOAD',
                                                    Udesk.enums.inspectDataSources.ticket.id
                                                ),
                                            disabled:
                                                !hasFeature ||
                                                !hasFeature('task:template:auto:edit'),
                                        },
                                        isEdit:
                                            privates.conditionList_ticket.length &&
                                            hasFeature &&
                                            hasFeature('task:template:auto:edit'),
                                        judgeStrategy:
                                            privates.model.automaticAdd.ticket.baseFilter
                                                .judgeStrategy,
                                        customJudgeLogic:
                                            privates.model.automaticAdd.ticket.baseFilter
                                                .customJudgeLogic,
                                        conditionList: privates.conditionList_ticket,
                                        editFilterOhter: actions.editFilterOhterTicket,
                                        fieldsFilterChange: actions.fieldsFilterChange,
                                        querryType: 'manualAdd',
                                        cancel: actions.handleConditionCancel,
                                        applyAction: actions.handleConditionApplyTicket,
                                        customName: privates.customName,
                                        customId: privates.customId,
                                        type: Udesk.enums.inspectDataSources.ticket.id,
                                        // taskId={this.props.match.params.taskId}
                                        taskName: this.props.sdkOptions.props.task.name,
                                        filterList: [
                                            'f_8',
                                            'f_4',
                                            'f_6',
                                            'f_7',
                                            'r_1',
                                            'r_2',
                                            'r_3',
                                        ],
                                        disabled: !(
                                            hasFeature && hasFeature('task:template:auto:edit')
                                        ),
                                        autoMateLoadConf:
                                            privates.model.automaticAdd.ticket.autoMateLoadConf,
                                        isAutoExecute:
                                            privates.model.automaticAdd.ticket.isAutoExecute,
                                        onTimingAddChange: actions.onTimingAddChangeTicket,
                                        isCollection: isCollection,
                                    }}
                                    videoProps={{
                                        showForm: Boolean(
                                            privates.model.processStatus?.MIXED_AUTOLOAD?.[
                                                Udesk.enums.inspectDataSources.videoCall.id
                                            ]
                                        ),
                                        switchProps: {
                                            checked:
                                                privates.model.processStatus?.MIXED_AUTOLOAD?.[
                                                    Udesk.enums.inspectDataSources.videoCall.id
                                                ] === 1,
                                            onChange: () =>
                                                actions.changeStatus(
                                                    'MIXED_AUTOLOAD',
                                                    Udesk.enums.inspectDataSources.videoCall.id
                                                ),
                                            disabled:
                                                !hasFeature ||
                                                !hasFeature('task:template:auto:edit'),
                                        },
                                        isEdit:
                                            privates.conditionList_video.length &&
                                            hasFeature &&
                                            hasFeature('task:template:auto:edit'),
                                        judgeStrategy:
                                            privates.model.automaticAdd.video.baseFilter
                                                .judgeStrategy,
                                        customJudgeLogic:
                                            privates.model.automaticAdd.video.baseFilter
                                                .customJudgeLogic,
                                        conditionList: privates.conditionList_video,
                                        editFilterOhter: actions.editFilterOhterVideo,
                                        fieldsFilterChange: actions.fieldsFilterChange,
                                        querryType: 'manualAdd',
                                        cancel: actions.handleConditionCancel,
                                        applyAction: actions.handleConditionApplyVideo,
                                        customName: privates.customName,
                                        customId: privates.customId,
                                        type: Udesk.enums.inspectDataSources.videoCall.id,
                                        // taskId={this.props.match.params.taskId}
                                        taskName: this.props.sdkOptions.props.task.name,
                                        filterList: [
                                            'f_8',
                                            'f_4',
                                            'f_6',
                                            'f_7',
                                            'r_1',
                                            'r_2',
                                            'r_3',
                                        ],
                                        disabled: !(
                                            hasFeature && hasFeature('task:template:auto:edit')
                                        ),
                                        autoMateLoadConf:
                                            privates.model.automaticAdd.video.autoMateLoadConf,
                                        isAutoExecute:
                                            privates.model.automaticAdd.video.isAutoExecute,
                                        onTimingAddChange: actions.onTimingAddChangeVideo,
                                        isCollection: isCollection,
                                    }}
                                    surveyProps={{
                                        showForm: Boolean(
                                            privates.model.processStatus?.MIXED_AUTOLOAD?.[
                                                Udesk.enums.inspectDataSources.survey.id
                                            ]
                                        ),
                                        switchProps: {
                                            checked:
                                                privates.model.processStatus?.MIXED_AUTOLOAD?.[
                                                    Udesk.enums.inspectDataSources.survey.id
                                                ] === 1,
                                            onChange: () =>
                                                actions.changeStatus(
                                                    'MIXED_AUTOLOAD',
                                                    Udesk.enums.inspectDataSources.survey.id
                                                ),
                                            disabled:
                                                !hasFeature ||
                                                !hasFeature('task:template:auto:edit'),
                                        },
                                        isEdit:
                                            privates.conditionList_survey.length &&
                                            hasFeature &&
                                            hasFeature('task:template:auto:edit'),
                                        judgeStrategy:
                                            privates.model.automaticAdd.survey.baseFilter
                                                .judgeStrategy,
                                        customJudgeLogic:
                                            privates.model.automaticAdd.survey.baseFilter
                                                .customJudgeLogic,
                                        conditionList: privates.conditionList_survey,
                                        editFilterOhter: actions.editFilterOhterSurvey,
                                        fieldsFilterChange: actions.fieldsFilterChange,
                                        querryType: 'manualAdd',
                                        cancel: actions.handleConditionCancel,
                                        applyAction: actions.handleConditionApplySurvey,
                                        customName: privates.customName,
                                        customId: privates.customId,
                                        type: Udesk.enums.inspectDataSources.survey.id,
                                        // taskId={this.props.match.params.taskId}
                                        taskName: this.props.sdkOptions.props.task.name,
                                        filterList: [
                                            'f_8',
                                            'f_4',
                                            'f_6',
                                            'f_7',
                                            'r_1',
                                            'r_2',
                                            'r_3',
                                        ],
                                        disabled: !(
                                            hasFeature && hasFeature('task:template:auto:edit')
                                        ),
                                        autoMateLoadConf:
                                            privates.model.automaticAdd.survey.autoMateLoadConf,
                                        isAutoExecute:
                                            privates.model.automaticAdd.survey.isAutoExecute,
                                        onTimingAddChange: actions.onTimingAddChangeSurvey,
                                        isCollection: isCollection,
                                    }}
                                />
                            </CardLayout>
                        )}

                        {/* 2、自动抽检 */}
                        <CardLayout
                            cardId="automaticSamplingInspection"
                            title={
                                UdeskLocales.current.pages.tasks.manage.template.automaticAdd.index
                                    .automaticSamplingInspection
                            }
                            tip={
                                UdeskLocales.current.pages.tasks.manage.template.automaticAdd.index
                                    .automaticSamplingInspectionTip
                            }
                            showContent={Boolean(privates.model.processStatus.SAMPLE)}
                            switchProps={{
                                checked: privates.model.processStatus.SAMPLE === 1,
                                onChange: () => actions.changeStatus('SAMPLE'),
                                disabled: !hasFeature || !hasFeature('task:template:auto:edit'),
                            }}
                            canEdit={hasFeature && hasFeature('task:template:auto:edit')}
                            onSave={actions.saveAutomaticSamplingInspection}
                        >
                            <TaskConditionGather
                                conditions={privates.conditions}
                                fields={privates.model.customFields}
                                onChanged={actions.conditionsChanged}
                                disabled={!hasFeature || !hasFeature('task:template:auto:edit')}
                                taskId={this.props.match.params.taskId}
                                taskName={this.props.sdkOptions.props.task.name}
                                type={privates.type}
                            />

                            {!isComment ? (
                                <>
                                    <div style={{ margin: '16px 0px' }}>
                                        <Space>
                                            <Checkbox
                                                checked={Boolean(
                                                    privates.everyAgentCheckUpperLimit.status
                                                )}
                                                onChange={
                                                    actions.onEveryAgentCheckUpperLimitStatusChange
                                                }
                                            >
                                                {
                                                    UdeskLocales.current.pages.tasks.manage.template
                                                        .automaticAdd.index.everyAgentCheckLimit
                                                }
                                            </Checkbox>
                                            <Select
                                                options={Udesk.enums.samplingFrequencyTypes
                                                    .filter((i) => i.id > 1)
                                                    .map((i) => ({
                                                        label: i.everyAgentCheckLimitName(),
                                                        value: i.id,
                                                    }))}
                                                style={{ width: 150 }}
                                                value={privates.everyAgentCheckUpperLimit.cycle}
                                                onChange={actions.onEveryAgentCheckUpperLimitChange.params(
                                                    'cycle'
                                                )}
                                                disabled={
                                                    !privates.everyAgentCheckUpperLimit.status
                                                }
                                            />
                                            <InputNumber
                                                style={{ width: 200 }}
                                                value={privates.everyAgentCheckUpperLimit.numLimit}
                                                onChange={actions.onEveryAgentCheckUpperLimitChange.params(
                                                    'numLimit'
                                                )}
                                                disabled={
                                                    !privates.everyAgentCheckUpperLimit.status
                                                }
                                            />
                                        </Space>
                                    </div>

                                    <div>
                                        <Space>
                                            <Checkbox
                                                checked={Boolean(
                                                    privates.everyAgentCheckFloorLimit.status
                                                )}
                                                onChange={
                                                    actions.onEveryAgentCheckFloorLimitStatusChange
                                                }
                                            >
                                                {/* 每客服抽取下限 */}
                                                {
                                                    UdeskLocales['current'].pages.tasks.manage
                                                        .template.automaticAdd.templateNew
                                                        .eachCustomerServiceRepresentativeCanSelectALowerLimit
                                                }
                                            </Checkbox>

                                            <Select
                                                options={Udesk.enums.samplingFrequencyTypes
                                                    .filter((i) => i.id > 1)
                                                    .map((i) => ({
                                                        label: i.everyAgentCheckLimitName(),
                                                        value: i.id,
                                                    }))}
                                                style={{ width: 150 }}
                                                value={privates.everyAgentCheckFloorLimit.cycle}
                                                onChange={actions.onEveryAgentCheckFloorLimitChange.params(
                                                    'cycle'
                                                )}
                                                disabled={
                                                    !privates.everyAgentCheckFloorLimit.status
                                                }
                                            />
                                            <InputNumber
                                                style={{ width: 200 }}
                                                value={privates.everyAgentCheckFloorLimit.numLimit}
                                                onChange={actions.onEveryAgentCheckFloorLimitChange.params(
                                                    'numLimit'
                                                )}
                                                disabled={
                                                    !privates.everyAgentCheckFloorLimit.status
                                                }
                                            />
                                        </Space>
                                    </div>
                                </>
                            ) : null}
                        </CardLayout>

                        {/* 自动分配 */}
                        <CardLayout
                            cardId="automaticAllocation"
                            title={
                                UdeskLocales.current.pages.tasks.manage.template.automaticAdd.index
                                    .automaticAllocation
                            }
                            tip={[
                                UdeskLocales.current.pages.tasks.manage.template.automaticAdd.index
                                    .automaticAllocationTip,
                                UdeskLocales.current.pages.tasks.manage.template.automaticAdd.index
                                    .automaticAllocationTip2,
                            ]}
                            showContent={Boolean(privates.model.processStatus.ASSIGN)}
                            switchProps={{
                                checked: privates.model.processStatus.ASSIGN === 1,
                                onChange: () => actions.changeStatus('ASSIGN'),
                                disabled: !hasFeature || !hasFeature('task:template:auto:edit'),
                            }}
                            canEdit={hasFeature && hasFeature('task:template:auto:edit')}
                            onSave={actions.saveAutomaticAllocation}
                        >
                            <If condition={privates.model.processStatus.ASSIGN}>
                                <AutoAssign
                                    disabled={disabled}
                                    assignShowType={privates.assignShowType}
                                    onAssignTypeChange={actions.onAssignTypeChange}
                                    isComment={isComment}
                                    sampleAssign={privates.sampleAssign}
                                    onValueChanged={(key, e) =>
                                        this.actions.onValueChanged(privates, key, e)
                                    }
                                    model={privates.model}
                                    sampleAssignListChanged={actions.sampleAssignListChanged}
                                    taskId={this.props.match.params.taskId}
                                    taskName={this.props.sdkOptions.props.task.name}
                                    type={privates.type}
                                    defaultSampleAssignConf={privates.defaultSampleAssignConf}
                                    sdkOptions={props.sdkOptions}
                                    reviewAssign={privates.reviewAssign}
                                    reviewAssignSecondLevel={privates.reviewAssignSecondLevel}
                                    reviewAssignListChanged={actions.reviewAssignListChanged}
                                    reviewAssignSecondLevelListChanged={
                                        actions.reviewAssignSecondLevelListChanged
                                    }
                                    defaultReviewAssignConf={privates.defaultReviewAssignConf}
                                    defaultReviewAssignConfSecondLevel={
                                        privates.defaultReviewAssignConfSecondLevel
                                    }
                                />
                            </If>
                        </CardLayout>

                        {/* 4、自动推送 */}
                        <CardLayout
                            cardId="automaticPush"
                            title={
                                UdeskLocales.current.pages.tasks.manage.template.automaticAdd.index
                                    .automaticPush
                            }
                            tip={[
                                UdeskLocales.current.pages.tasks.manage.template.automaticAdd.index
                                    .automaticPushTip,
                                UdeskLocales.current.pages.tasks.manage.template.automaticAdd.index
                                    .automaticPushTip2,
                            ]}
                            showContent={Boolean(privates.model.processStatus.MONITOR)}
                            switchProps={{
                                checked: privates.model.processStatus.MONITOR === 1,
                                onChange: () => actions.changeStatus('MONITOR'),
                                disabled: !hasFeature || !hasFeature('task:template:auto:edit'),
                            }}
                            canEdit={hasFeature && hasFeature('task:template:auto:edit')}
                            onSave={actions.saveAutomaticPush}
                            cardBodyStyle={{ padding: '40px 0 24px' }}
                        >
                            <div className="tasks-automatic-add-card-body-push-list">
                                <div className={`tasks-automatic-add-push-item`}>
                                    <Radio.Group
                                        value={privates.pushTypeRadioValue}
                                        onChange={actions.onPushTypeRadioChange}
                                        style={{ marginBottom: 16 }}
                                        buttonStyle="solid"
                                    >
                                        {Udesk.enums.messageType
                                            .filter((messageType) => messageType > 1)
                                            .map((messageType, index, arr) => (
                                                <Radio.Button value={messageType.id}>
                                                    {messageType.name}
                                                </Radio.Button>
                                            ))}
                                    </Radio.Group>
                                    <div className="tasks-automatic-add-push-item-content">
                                        <Tabs
                                            type="editable-card"
                                            onChange={actions.onPushConfigTabsChange}
                                            // activeKey={activeKey}
                                            onEdit={actions.onEdit.params(
                                                privates.pushTypeRadioValue
                                            )}
                                            addIcon={
                                                <div style={{ padding: 8 }}>
                                                    {UdeskLocales.current.labels.create +
                                                        UdeskLocales.current.pages.tasks.manage
                                                            .template.automaticAdd.index.push}
                                                </div>
                                            }
                                        >
                                            {privates.automaticPushConfigList
                                                .filter(
                                                    (item) =>
                                                        item.monitorConf &&
                                                        item.monitorConf.messageType ===
                                                            privates.pushTypeRadioValue
                                                )
                                                .map((item, index) => (
                                                    <Tabs.TabPane
                                                        tab={`${
                                                            UdeskLocales.current.pages.tasks.manage
                                                                .template.automaticAdd.index.push
                                                        }${index + 1}`}
                                                        key={item._id}
                                                        closable={true}
                                                    >
                                                        <MassageConfiguration
                                                            key={item._id}
                                                            type={privates.pushTypeRadioValue}
                                                            messagePushTypeFilter={
                                                                isWechatQa
                                                                    ? (i) => i.id <= 2
                                                                    : undefined
                                                            }
                                                            configuration={Udesk.utils.object.deepCopy(
                                                                item
                                                            )}
                                                            onMassageConfigurationChange={actions.onMassageConfigurationChange.params(
                                                                item
                                                            )}
                                                            onConfigurationChange={
                                                                actions.onConfigurationChange
                                                            }
                                                            taskId={this.props.match.params.taskId}
                                                            taskName={
                                                                this.props.sdkOptions.props.task
                                                                    .name
                                                            }
                                                            taskType={
                                                                privates.model.task
                                                                    .inspectDataSource
                                                            }
                                                            taskTypeList={[
                                                                1, 3, 6, 7, 8, 14, 17, 19,
                                                            ]}
                                                            disabled={
                                                                !hasFeature ||
                                                                !hasFeature(
                                                                    'task:template:auto:edit'
                                                                )
                                                            }
                                                            isWechatQa={isWechatQa}
                                                        />
                                                    </Tabs.TabPane>
                                                ))}
                                        </Tabs>
                                    </div>
                                </div>
                            </div>
                        </CardLayout>

                        {/* 成绩查看 */}
                        <CardLayout
                            cardId="viewGrade"
                            title={/* 成绩查看 */UdeskLocales['current'].pages.tasks.manage.template.automaticAdd.templateNew.resultsView}
                            tip={/* 开启后支持配置成绩公布与查看时机，可实时查看或按定时规则查看 */UdeskLocales['current'].pages.tasks.manage.template.automaticAdd.templateNew.afterTheStartOfTheSupportConfigurationResultsAreAvailableAndTheTimingCanBeViewedInRealTimeOrAccordingToTheRegularRules}
                            showContent={true}
                            canEdit={hasFeature && hasFeature('task:template:auto:edit')}
                            onSave={actions.saveViewGrade}
                        >
                            <ViewGrade
                                value={privates.viewGradeConfig}
                                onChange={actions.onViewGradeConfigChange}
                                disabled={!hasFeature || !hasFeature('task:template:auto:edit')}
                                type={privates.type}
                                taskName={this.props.sdkOptions.props.task.name}
                            />
                        </CardLayout>

                        {/* 5、自动评估 */}
                        <CardLayout
                            cardId="automaticAssess"
                            title={
                                UdeskLocales.current.pages.tasks.manage.template.automaticAdd.index
                                    .automaticAssess
                            }
                            tip={
                                UdeskLocales.current.pages.tasks.manage.template.automaticAdd.index
                                    .automaticAssessTip
                            }
                            showContent={Boolean(privates.model.processStatus.AUTO_ASSESSMENT)}
                            switchProps={{
                                checked: privates.model.processStatus.AUTO_ASSESSMENT === 1,
                                onChange: () => actions.changeStatus('AUTO_ASSESSMENT'),
                                disabled: !hasFeature || !hasFeature('task:template:auto:edit'),
                            }}
                            canEdit={hasFeature && hasFeature('task:template:auto:edit')}
                            onSave={actions.saveAutomaticAssess}
                        >
                            <TaskAssessRulesGather
                                rules={[...privates.assessRules]}
                                taskId={privates.model.taskId}
                                fields={privates.model.customFields}
                                onChanged={actions.assessRulesChanged}
                                taskName={this.props.sdkOptions.props.task.name}
                                type={privates.type}
                                disabled={!hasFeature || !hasFeature('task:template:auto:edit')}
                            />
                        </CardLayout>

                        {/* 案例库同步 */}
                        <CardLayout
                            cardId="caseLibrary"
                            title={
                                UdeskLocales.current.pages.tasks.manage.template.automaticAdd.index
                                    .caseLibrary
                            }
                            tip={
                                UdeskLocales.current.pages.tasks.manage.template.automaticAdd.index
                                    .caseLibrarySyncTip
                            }
                            showContent={Boolean(privates.model.processStatus.CASE)}
                            switchProps={{
                                checked: privates.model.processStatus.CASE === 1,
                                onChange: () => actions.changeStatus('CASE'),
                                disabled: !hasFeature || !hasFeature('task:template:auto:edit'),
                            }}
                            canEdit={hasFeature && hasFeature('task:template:auto:edit')}
                            onSave={actions.saveCaseLibrary}
                        >
                            <UdeskList
                                deleteItem={actions.deleteCaseItem}
                                addItem={actions.addCaseItem}
                                addBtnText={
                                    UdeskLocales.current.pages.tasks.manage.template.automaticAdd
                                        .index.addCase
                                }
                            >
                                {privates.caseConfigList.map((item, index) => {
                                    // privates.automaticPushConfigList.map((item, index) => {
                                    return (
                                        <CaseConfig
                                            key={item._id}
                                            onChange={actions.onCaseItemChange.params(index)}
                                            autoMateCaseConf={item}
                                            taskId={this.props.match.params.taskId}
                                        />
                                    );
                                })}
                            </UdeskList>
                        </CardLayout>

                        {/* 5、抽检目标 */}
                        <CardLayout
                            cardId="samplingTarget"
                            title={
                                /* 抽检目标 */ locales.pages.tasks.manage.template.automaticAdd
                                    .templateNew.samplingInspectionTarget
                            }
                            tip={
                                /* 设定人工抽检应完成的目标，目标未达成或者超过时给出提示，例如每客服每月应完成抽检100条，低于80条时，质检、抽检页面进行提示。 */ locales
                                    .pages.tasks.manage.template.automaticAdd.templateNew
                                    .setTheTargetToBeCompletedByManualSamplingInspectionWhenTheTargetIsNotReachedOrExceededAPromptWillBeGivenForExampleEveryCustomerServiceShouldCompleteSamplingInspectionsEveryMonthWhenTheNumberIsLessThan80APromptWillBeGivenOnTheQualityInspectionAndSamplingInspectionPage
                            }
                            showContent={true}
                            canEdit={hasFeature && hasFeature('task:template:auto:edit')}
                            onSave={actions.samplingTargetSave}
                        >
                            <SamplingTarget
                                ref={privates.samplingTargetRef}
                                taskId={this.props.match.params.taskId}
                            />
                        </CardLayout>

                        {/* 6、抽检复核详情配置/业务配置 */}
                        <CardLayout
                            cardId="reexaminationComplaint"
                            title={
                                UdeskLocales.current.pages.tasks.manage.template.automaticAdd.index
                                    .spoktReviewDetail
                            }
                            tip={
                                UdeskLocales.current.pages.tasks.manage.template.automaticAdd.index
                                    .spoktReviewDetailTip
                            }
                            showContent={true}
                            canEdit={hasFeature && hasFeature('task:template:auto:edit')}
                            onSave={actions.saveReexaminationComplaint}
                        >
                            <BusinessConfig
                                isTicket={isTicket}
                                isComment={isComment}
                                disabled={disabled}
                                value={{
                                    inspectionOptionsExport: this.privates.inspectionOptionsExport,
                                    inspectionOptionsList: this.privates.inspectionOptionsList,
                                    spoktOptions: this.privates.spoktOptions,
                                    fastSampleInDetailList: this.privates.fastSampleInDetailList,
                                    spoketOptionsExport: this.privates.spoketOptionsExport,
                                    spoktOptionsList: this.privates.spoktOptionsList,
                                    reviewOptions: this.privates.reviewOptions,
                                    reviewOptionsExport: this.privates.reviewOptionsExport,
                                    reviewOptionsList: this.privates.reviewOptionsList,
                                    permitComplainCount: this.privates.permitComplainCount,
                                    complainPeriod: this.privates.complainPeriod,
                                    reviewAging: this.privates.reviewAging,
                                    complainPeriodMode: this.privates.complainPeriodMode,
                                    refreshComplainPeriodAndNum:
                                        this.privates.refreshComplainPeriodAndNum,
                                    complainCycle: this.privates.complainCycle,
                                    complainScope: this.privates.complainScope,
                                    complainDeadTime: this.privates.complainDeadTime,
                                    reviewCycle: this.privates.reviewCycle,
                                    reviewScope: this.privates.reviewScope,
                                    reviewDeadTime: this.privates.reviewDeadTime,
                                    complainDeadCount: this.privates.complainDeadCount,
                                    samplePeriodMode: this.privates.samplePeriodMode,
                                    sampleAging: this.privates.sampleAging,
                                    sampleCycle: this.privates.sampleCycle,
                                    sampleScope: this.privates.sampleScope,
                                    sampleDeadTime: this.privates.sampleDeadTime,
                                    appealOptionsExport: this.privates.appealOptionsExport,
                                    appaelable: this.privates.appaelable,
                                    callDetailShowConfigList:
                                        this.privates.callDetailShowConfigList,
                                    callDetailShowConfigOption:
                                        this.privates.callDetailShowConfigOption,
                                    overSecondsDurationShow: this.privates.overSecondsDurationShow,
                                    remarkModel: this.privates.remarkModel,
                                    finalReview: this.privates.finalReview,
                                    sdkShowCaseLibrary: this.privates.sdkShowCaseLibrary,
                                }}
                                onValueChanged={(key, e) =>
                                    this.actions.onValueChanged(privates, key, e)
                                }
                                onAppealValueChanged={this.actions.onAppealValueChanged}
                                onAppealableChanged={this.actions.onAppealableChanged}
                                callDetaiConfigChanged={this.actions.callDetaiConfigChanged}
                                onRemarkModelChange={this.actions.onRemarkModelChange}
                            />
                        </CardLayout>

                        {/* 业务小结 */}
                        <CardLayout
                            cardId="businessSummary"
                            title={
                                /* 业务小结 */ UdeskLocales['current'].pages.tasks.manage.template
                                    .automaticAdd.templateNew.businessSummary
                            }
                            tip={
                                /* 由大模型自动生成业务小结，根据业务情况可自定义生成维度 */ UdeskLocales[
                                    'current'
                                ].pages.tasks.manage.template.automaticAdd.templateNew
                                    .automaticallyGenerateBusinessSummariesFromLargeModelsAndCustomizeDimensionsBasedOnBusinessSituations
                            }
                            showContent={true}
                            switchProps={{
                                checked: privates.model.processStatus.BUSINESS_SUMMARY === 1,
                                onChange: () => actions.changeStatus('BUSINESS_SUMMARY'),
                                disabled: !hasFeature || !hasFeature('task:template:auto:edit'),
                            }}
                            canEdit={false}
                            cardBodyStyle={{ padding: 16 }}
                        >
                            <BusinessSummaryTable
                                type={privates.type}
                                taskId={this.props.match.params.taskId}
                                lang={privates.model.task.lang}
                            />
                        </CardLayout>

                        {/* 话题分析 */}
                        <CardLayout
                            cardId="topicAnalysis"
                            title={
                                /* 话题分析 */ UdeskLocales['current'].pages.tasks.manage.template
                                    .automaticAdd.templateNew.topicAnalysis
                            }
                            tip={
                                /* 识别对话中的话题，根据业务情况可自定义话题维度 */ UdeskLocales[
                                    'current'
                                ].pages.tasks.manage.template.automaticAdd.templateNew
                                    .identifyTheTopicInTheConversationAndCustomizeTheTopicDimensionAccordingToTheBusinessSituation
                            }
                            showContent={true}
                            switchProps={{
                                checked: privates.model.processStatus.TOPIC_SETTING === 1,
                                onChange: () => actions.changeStatus('TOPIC_SETTING'),
                                disabled: !hasFeature || !hasFeature('task:template:auto:edit'),
                            }}
                            canEdit={false}
                            cardBodyStyle={{ padding: 16 }}
                        >
                            <TopicAnalysisTable
                                type={privates.type}
                                taskId={this.props.match.params.taskId}
                                lang={privates.model.task.lang}
                            />
                        </CardLayout>
                    </CusTabs>

                    <If condition={privates.model.processCreateStatus.processStatus === 4}>
                        <div
                            className="tasks-manage-template-basic-info-index-footer"
                            style={{ padding: 16 }}
                        >
                            <Button type="primary" onClick={actions.handleNext}>
                                {privates.model.processCreateStatus.related === 1 &&
                                Udesk.business.task.isTextDialogue(
                                    privates.model.processCreateStatus.inspectDataSource
                                )
                                    ? locales.pages.tasks.manage.template.basicInfo.index.complete
                                    : locales.pages.tasks.manage.template.basicInfo.index.next}
                            </Button>
                            {(this.privates.model.processCreateStatus.related === 1 &&
                                Udesk.business.task.isTextDialogue(
                                    privates.model.processCreateStatus.inspectDataSource
                                )) || (
                                <Button style={{ marginLeft: 8 }} onClick={actions.sendAjaxToNext}>
                                    {locales.pages.tasks.manage.template.basicInfo.index.skip}
                                </Button>
                            )}
                        </div>
                    </If>
                </If>
            </Page>
        );
    }
}
